import { OperationStatus, readTimesOf } from '@/ble/entities/operationStatus'
import { SwitchStatus, isStandSwitchPressed } from '@/ble/entities/switchStatus'
import { TagId } from '@/ble/entities/tagId'

export type DispatchRoute = 'complete' | 'confirm' | 'error'

export type DispatchInput = {
  action: 'rental' | 'return'
  outcome: OperationStatus
  switchStatus: SwitchStatus
  forcedUnlock: boolean // = capabilities.canDistinguishReaders
  area1TagId: TagId | null
  area2TagId: TagId | null
}

// platform share_usecase.dart _shouldShowPopup(L278-322) の 4分岐を 1:1 移植。
function shouldShowPopup(input: DispatchInput): boolean {
  const {
    action,
    outcome,
    switchStatus,
    forcedUnlock,
    area1TagId,
    area2TagId,
  } = input
  const readTimes = readTimesOf(outcome)
  const switchPressed = isStandSwitchPressed({ when: action, switchStatus })

  // (a) 新ファームで第2リーダーのみ読取成功 → POPUP 不要（complete）
  if (forcedUnlock && readTimes === 1 && outcome === 'partialReadArea2') {
    return false
  }
  // (b) 強制解錠でタグ読取なし(0/1)かつ非押下 → POPUP
  if (forcedUnlock && (readTimes === 0 || readTimes === 1) && !switchPressed) {
    return true
  }
  // (c) 強制解錠で readTimes==2 かつ area 不一致かつ非押下 → POPUP
  //     platform の area1TagId != area2TagId は TagId 値比較 → ?.id で写す（両/片 null 込み）
  if (
    forcedUnlock &&
    readTimes === 2 &&
    (area1TagId?.id ?? null) !== (area2TagId?.id ?? null) &&
    !switchPressed
  ) {
    return true
  }
  // (d) 非強制(legacy)で readTimes==1 かつ非押下 → POPUP
  if (!forcedUnlock && readTimes === 1 && !switchPressed) {
    return true
  }
  return false
}

// 振り分け: 入口の irregular ガード（唯一の意図的逸脱）→ popup(confirm) → failed-timeout(error) → complete。
export function decideOperationDispatch(input: DispatchInput): DispatchRoute {
  // irregular は取引に載せない（自動POST事故の遮断）。platform share 経路は
  // このガードを持たず '00000000' 自動POSTする既知の穴＝複製しない。
  if (input.outcome === 'irregular') return 'error'

  if (shouldShowPopup(input)) return 'confirm'

  // umbrella_rental/return の failed-timeout 分岐（forcedUnlock では (b) が先に confirm を返すため
  // ここに来る failed は legacy の非押下のみ）。
  const switchPressed = isStandSwitchPressed({
    when: input.action,
    switchStatus: input.switchStatus,
  })
  if (input.outcome === 'failed' && !switchPressed) return 'error'

  return 'complete'
}
